// BlockContext.js
import { createContext } from '@wordpress/element';

const BlockContext = createContext();

export default BlockContext;
